import { loadCommitFileRows } from "./commitFileRows";
import type { Transaction } from "@rocicorp/zero";
import type { Schema } from "./generatedDrizzleSchema";
import { zql } from "./generatedDrizzleSchema";

/**
 * Build a file map from commitFiles + blobs.
 * Returns { "/<path>": content } for every file in the commit.
 */
export async function buildFileMap(
  run: Pick<Transaction<Schema>, "run">,
  commitId: string
): Promise<Record<string, string>> {
  const files = await loadCommitFileRows(run, commitId);
  const hashes = [...new Set(files.map((f) => f.blobHash))];
  const blobs =
    hashes.length > 0
      ? await run.run(
          zql.blobs
            .where("hash", "IN", hashes)
            .where("tenantId", files[0]!.tenantId)
        )
      : [];
  const blobMap = new Map(blobs.map((b) => [b.hash, b.content]));

  const result: Record<string, string> = {};
  for (const f of files) {
    const content = blobMap.get(f.blobHash);
    if (content != null) result[`/${f.path}`] = content;
  }
  return result;
}
